import React from 'react';

import styles from './Message.module.css';
import logo from '../pages/images/logo-circle.svg';

const Message: React.FC = () => {
  return (
    <div className={styles.message}>
      <div className={styles.messageInner}>
        <img src={logo} alt="Logo" className={styles.icon} />
        <div className={styles.messageDetails}>
          <h2>Seven Monks</h2>
          <div className={styles.teaser}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </div>
        </div>
        <div className={styles.messageAge}>5m</div>
      </div>
    </div>
  );
};

export default Message;
